module.exports = require('./helpers/bundle-url').getBundleURL('8sReV') + "logo-dark.eefe0b7f.svg";